"use client";

import * as React from "react";
import { useRouter } from "next/navigation";
import { Modal, Button } from "@/components/ui";
import { apiPatch } from "@/lib/api-client";
import { cn } from "@/lib/cn";

/**
 * Popup hỏi khối lớp đang dạy — hiện khi giáo viên chưa chọn (vd login Google,
 * hoặc vừa đăng ký qua modal). Tự mở khi được render; lưu xong → refresh + `onDone`.
 * Parent quyết định KHI NÀO render (chỉ render khi `teachingGrade == null`).
 */
export function GradePrompt({ onDone }: { onDone?: () => void }) {
  const router = useRouter();
  const [open, setOpen] = React.useState(true);
  const [grade, setGrade] = React.useState<number | null>(null);
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  async function save() {
    if (!grade) return;
    setSaving(true);
    setError(null);
    try {
      await apiPatch("/api/me/teaching-grade", { teachingGrade: grade });
      setOpen(false);
      router.refresh();
      onDone?.();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Không lưu được. Thử lại nhé.");
      setSaving(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => {}}
      size="sm"
      title="Bạn đang dạy khối lớp nào?"
      description="Chọn khối để chúng tôi gợi ý tài liệu phù hợp cho bạn."
    >
      <div className="space-y-4">
        <div className="grid grid-cols-5 gap-2">
          {[1, 2, 3, 4, 5].map((g) => (
            <button
              key={g}
              type="button"
              onClick={() => setGrade(g)}
              className={cn(
                "flex flex-col items-center gap-1 rounded-lg border py-3 text-body-sm font-semibold transition-colors",
                grade === g
                  ? "border-primary bg-primary/10 text-primary"
                  : "border-border-strong text-foreground-secondary hover:border-primary/50"
              )}
            >
              Lớp {g}
            </button>
          ))}
        </div>
        {error && <p className="text-center text-caption text-danger">{error}</p>}
        <Button block size="lg" onClick={save} isLoading={saving} disabled={!grade}>
          Tiếp tục
        </Button>
      </div>
    </Modal>
  );
}
